import { ROLES } from '../../_config/roles';

export const cleanInputs = () => {
    document.getElementById('seller_cod').value = '';
    document.getElementById('seller_full_name').value = '';
    document.getElementById('seller_login').value = '';
    document.getElementById('seller_password').value = '';
}

export const buildCreateSellerBody = (company) => {
    return {
        seller_cod: document.getElementById('seller_cod').value,
        full_name: document.getElementById('seller_full_name').value,
        login: document.getElementById('seller_login').value,
        password: document.getElementById('seller_password').value,
        rol: ROLES.seller,
        company
    }
}

export const validateCreateSeller = (body) => {
    if(body.cod === null || body.cod === ''){
        throw new Error('Código vendedor vacío');
    }

    if(body.full_name === null || body.full_name === ''){
        throw new Error('Nombre vacío');
    }

    if(body.login === null || body.login === ''){
        throw new Error('Usuario vacío');
    }

    if(body.password === null || body.password === ''){
        throw new Error('Constraseña vacía');
    }
}

export const validateEditSeller = (body) => {
    if(body.cod === null || body.cod === ''){
        throw new Error('Código vendedor vacío');
    }

    if(body.full_name === null || body.full_name === ''){
        throw new Error('Nombre vacío');
    }

    if(body.login === null || body.login === ''){
        throw new Error('Usuario vacío');
    }
}